import { useQuery } from '@tanstack/react-query'
import getMetricEvents from '@/services/ruutsApi/getMetricEvents'
import { queryKeys } from './queryKeys'

export const useMetricEvents = ({
  farmId,
  namespace,
  year,
  paddockIds = undefined,
  enabled = true,
}) =>
  useQuery({
    queryKey: queryKeys.metricEvents({ farmId, namespace, year, paddockIds }),
    queryFn: ({ signal }) => getMetricEvents({ farmId, namespace, year, paddockIds, signal }),
    enabled: enabled && !!farmId,
  })
